<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">장비 목록</div>
        <span class="mr-r5">수집여부</span>
        <div class="setting-addel">
          <!-- add 1210 height ie friendly -->
          <el-button size="mini" style="height:27px" @click="onCollectAll(true)"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" style="height:27px" @click="onCollectAll(false)"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button class="mr-r4" size="mini" type="primary" :disabled="!checkDifferenceObjListFlag" @click="onSaveButton">저장</el-button>
        <el-button class="mr-r4" size="mini" :disabled="!checkDifferenceObjListFlag" @click="onCancelButton">취소</el-button>
        <w-header-search-button @click="toggleSearchTool"/>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper ref="trapTable" :column-default="columnDefault" :data="objListDatas" :columns="columns" highlight-current-row remote :show-custom-header="true" :show-search-tool="showSearchTool">
        <template slot-scope="scope" slot="rawdata-flag-slot" @condition-change="onConditionChange">
          <el-switch v-model="scope.row.rawdataSaveFlagSnmptrap" active-value="1" inactive-value="0" @change="changeDifferenceDataFlag"/>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { isEqual, differenceWith, cloneDeep, isEmpty, every } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtils from '@/utils/message';
import snmptrapSettingAPI from '@/api/settings/log/snmptrap-settings';

export default {
  name: 'WObjListTable',
  data() {
    const columns = [
      {
        prop: 'rawdataSaveFlagSyslog',
        label: '수집',
        headerAlign: 'center',
        width: '60px',
        scopedSlot: 'rawdata-flag-slot',
      },
      {
        prop: 'objName',
        label: '장비명',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'ipaddressIpv4',
        label: 'IP주소',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'objtypeName',
        label: '장비종류',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'objCompanyName',
        label: '제조사',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'objProductId',
        label: '버전',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
    ];
    return {
      showSearchTool: false,
      objListDatas: [],
      objListOriginDatas: [],
      columns,
      selectedRow: [],
      checkDifferenceObjListFlag: false,
      columnDefault,
      collectAll: false,
      start: 0,
      limit: 25,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * snmptrap의 장비 목록을 조회해온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      const searchParam = this.$refs.trapTable.getParameter();
      const params = {
        searchParam,
      };
      snmptrapSettingAPI.getSnmptrapObjList(params).then((response) => {
        this.objListDatas = cloneDeep(response.data.data);
        this.objListOriginDatas = cloneDeep(response.data.data);
        this.$nextTick(() => {
          this.changeDifferenceDataFlag();
        });
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '장비목록', false));
        throw new Error(e);
      });
    },
    getStringFormatter(row, column, value) {
      if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },

    changeDifferenceDataFlag() {
      this.changeCollectAll();
      this.checkDifferenceObjListFlag = !isEqual(this.objListDatas, this.objListOriginDatas);
    },
    onCollectAll(value) {
      if (value) {
        // true : 전체 선택
        this.objListDatas.forEach((item) => {
          item.rawdataSaveFlagSnmptrap = '1';
        });
      } else {
        // false : 전체 선택 해제
        this.objListDatas.forEach((item) => {
          item.rawdataSaveFlagSnmptrap = '0';
        });
      }
      this.changeDifferenceDataFlag();
    },
    changeCollectAll() {
      if (isEmpty(this.objListDatas)) {
        this.collectAll = false;
        return;
      }
      if (every(this.objListDatas, { rawdataSaveFlagSnmptrap: '1' })) {
        this.collectAll = true;
      } else {
        this.collectAll = false;
      }
    },
    onConditionChange(value) {
      this.start = value.start;
      this.limit = value.limit;
      this.loadData();
    },
    /**
     * 장비별 Snmptrap 수집 설정 여부를 수정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveButton() {
      const params = differenceWith(this.objListDatas, this.objListOriginDatas, isEqual);
      snmptrapSettingAPI.updateSnmptrapGroupSetList(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
          this.loadData();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', false));
        throw new Error(e);
      });
    },
    onCancelButton() {
      this.objListDatas = cloneDeep(this.objListOriginDatas);
      this.changeDifferenceDataFlag();
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log/SnmpTrap/components/ObjListTable.vue